import { ActionList, ActionMenu } from "@primer/react";
import { TriangleDownIcon } from "@primer/octicons-react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useCommonContext } from "../../contexts/common";
import { RootState } from "../../state/reducers";
import styles from "./ComboboxTruong.module.css";
export type ComboboxTruongProps = {
    isReadonly?: boolean,
    value?: number,
    onValueChanged: (id: number) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined",
    trailingAction?: React.ElementType;
}
const ComboboxTruong = (props: ComboboxTruongProps) => {
    const dm_truongs = useSelector((state: RootState) => state.auth.user_info?.campus);
    const { translate } = useCommonContext();
    const { language } = useSelector((x: RootState) => x.common)
    const selectedData = useMemo(() => {
        if (props.value && dm_truongs) {
            return dm_truongs.find(x => x.id == props.value)
        }
        return undefined
    }, [dm_truongs, props.value])
    return (
        <div  style={{ width: "100%" }}>
            <ActionMenu
            >
                <ActionMenu.Button aria-label="Select school year"
                    trailingAction={props.trailingAction ?? TriangleDownIcon}
                    className="button-left"
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    {selectedData ? (language === "en" ? selectedData.ten_truong_en : selectedData.ten_truong) : translate("TruongCombobox.PlaceHolder")}
                </ActionMenu.Button>
                <ActionMenu.Overlay width="medium">
                    <ActionList selectionVariant="single">
                        {props.isShowClearButton &&
                            <ActionList.Item key={0} selected={props.value != undefined && 0 === props.value}
                                onSelect={() => {
                                    props.onValueChanged(0)
                                }}
                            >
                                {language === "en" ? "Select" : "Chọn trường"}
                            </ActionList.Item>
                        }
                        {dm_truongs && dm_truongs.map((item, index) => {
                            return (
                                <ActionList.Item key={item.id} selected={props.value != undefined && item.id === props.value}
                                    onSelect={() => {
                                        props.onValueChanged(item.id)
                                    }}
                                >
                                    {language === "en" ? item.ten_truong_en : item.ten_truong}
                                </ActionList.Item>
                            );
                        })}
                    </ActionList>

                </ActionMenu.Overlay>
            </ActionMenu >
            {/* <SelectBox dataSource={dm_truongs?.sort((a, b) => a.dm_coso_id - b.dm_coso_id)}
                displayExpr={language == "en" ? "ten_truong_en" : "viet_tat"}
                valueExpr={"id"}
                value={props.value}
                stylingMode={props.stylingMode || "outlined"}
                readOnly={props.isReadonly === true}
                placeholder={translate("DropDownTruong.Label.ChooseSchool")}
                width="100%"
                searchEnabled
                className={"default_selectbox " + (props.className ? props.className : "")}
                showClearButton={props.isShowClearButton === true}
                dropDownOptions={{
                    width: 400
                }}
                itemRender={(cell) => {
                    return (
                        <div className={styles.school}>
                            <div className={styles.logo}>
                                {cell.logo_url && <img src={`${cell.logo_url}`} />}
                            </div>
                            <div className={styles.name}>
                                {language == "en" ? cell.ten_truong_en : cell.viet_tat}
                            </div>
                        </div>
                    );
                }}
                onValueChanged={(e) => {
                    if (e.event) props.onValueChanged(e.value)
                }} /> */}
        </div>
    );
}

export { ComboboxTruong };

